<template>
  <div class="filters-wrapper">
    <div class="d-flex justify-content-between align-items-center">
      <span class="fw6">{{ $t('common.filters') }}</span>
      <button class="button reset-button" @click="resetHandler">
        {{ $t('common.reset') }}
      </button>
    </div>
    <District class="top-indent-6" />
    <Subway class="top-indent-12" />
    <Gender class="top-indent-12" />
    <Age class="top-indent-12" />
    <Cost class="top-indent-12" />
    <Schedule class="top-indent-12 mb-2" />
    <el-checkbox
      v-model="isChecked"
      :disabled="requestStatus"
      @change="handleChange"
    >
      {{ $t('common.outreach_training') }}
    </el-checkbox>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Age from '~/components/Search/Filters/Age'
import Cost from '~/components/Search/Filters/Cost'
import District from '~/components/Search/Filters/District'
import Gender from '~/components/Search/Filters/Gender'
import Schedule from '~/components/Search/Filters/Schedule'
import Subway from '~/components/Search/Filters/Subway'
//  @TODO reset values in the modals
export default {
  name: 'FiltersBlock',
  components: {
    Age,
    Cost,
    District,
    Gender,
    Schedule,
    Subway
  },
  data() {
    return {
      isChecked: false
    }
  },
  computed: {
    ...mapGetters({
      checked: 'search/searchOutdoor',
      searchLocation: 'search/searchLocation',
      requestStatus: 'search/getRequestStatus'
    })
  },
  watch: {
    checked: {
      immediate: true,
      handler(val) {
        this.isChecked = val
      }
    }
  },
  methods: {
    ...mapActions({
      setOutdoor: 'search/SET_OUTDOOR',
      resetFilters: 'search/RESET_FILTERS'
    }),
    async handleChange() {
      await this.setOutdoor(this.isChecked)
    },
    async resetHandler() {
      await this.resetFilters()
      this.$bus.$emit('resetDistricts')
      this.$bus.$emit('clear.schedule')
    }
  }
}
</script>

<style scoped lang="scss">
.filters-wrapper {
  width: 100%;
  padding: 15px 30px 31px 30px;
  background-color: white;
}
.top-indent-12 {
  margin-top: 12px;
}
.top-indent-6 {
  margin-top: 6px;
}
.reset-button {
  font-size: 12px;
  font-weight: 300;
}
</style>
